import { render, staticRenderFns } from "./SSOCallback.vue?vue&type=template&id=6f1559e2"
import script from "./SSOCallback.vue?vue&type=script&lang=js"
export * from "./SSOCallback.vue?vue&type=script&lang=js"
import style0 from "./SSOCallback.vue?vue&type=style&index=0&id=6f1559e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports